import { EasmArtifactsInventoryGridWebComponent } from './component/EasmArtifactsInventoryGridWebComponent';
import { WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY_GRID } from '../../webcomponents.constants';

export { EasmArtifactsInventoryGridWebComponent };

window.customElements.define(WEB_COMPONENT_EASM_ARTIFACTS_INVENTORY_GRID, EasmArtifactsInventoryGridWebComponent);
